import { Beaker, Syringe, Sparkles, BadgeCheck } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export const Studio = ({ t }) => {
  const badges = [
    { icon: Beaker, text: t.studio.badges.a },
    { icon: Syringe, text: t.studio.badges.b },
    { icon: Sparkles, text: t.studio.badges.c },
    { icon: BadgeCheck, text: t.studio.badges.d },
  ];
  return (
    <section
      id="studio"
      className="relative py-14 md:py-20 bg-bendito-bg"
      data-testid="studio-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-end">
          <div className="lg:col-span-5 reveal">
            <div className="eyebrow mb-3">{t.studio.eyebrow}</div>
            <h2 className="font-heading text-bendito-ink text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight">
              <span className="ink-underline">{t.studio.title}</span>
            </h2>
            <p className="text-bendito-muted mt-4 leading-relaxed">{t.studio.sub}</p>

            <ul className="mt-8 grid grid-cols-2 gap-x-5 gap-y-4">
              {badges.map((b, i) => {
                const Icon = b.icon;
                return (
                  <li key={i} className="flex items-start gap-3" data-testid={`studio-badge-${i}`}>
                    <Icon className="w-5 h-5 text-bendito-orange shrink-0 mt-0.5" strokeWidth={1.5} />
                    <span className="text-sm text-bendito-ink/90 leading-snug">{b.text}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-6 grid-rows-2 gap-2 md:gap-3 h-[420px] md:h-[520px]">
              <img
                src={ASSETS.studio[0]}
                alt="Studio interior detail"
                loading="lazy"
                className="col-span-4 row-span-2 w-full h-full object-cover"
              />
              <img
                src={ASSETS.studio[1]}
                alt="Studio interior"
                loading="lazy"
                className="col-span-2 row-span-1 w-full h-full object-cover"
              />
              <img
                src={ASSETS.studio[2]}
                alt="Studio interior"
                loading="lazy"
                className="col-span-2 row-span-1 w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Studio;
